import { createFileRoute } from '@tanstack/react-router';
import { PAYMENT_ADMIN_SOURCES } from '@/api/payment-admin/models';
import { PaymentDetailRoute } from '@/pages/acube-payments/detail-route';

/** Deep link a una riga del registro ACube: la lista sta già sotto. */
export const Route = createFileRoute(
  '/admin/_layout/acube-payments/_layout/$id'
)({
  component: AcubePaymentDetailRouteComponent,
});

function AcubePaymentDetailRouteComponent() {
  const { id } = Route.useParams();

  return (
    <PaymentDetailRoute target={{ source: PAYMENT_ADMIN_SOURCES.ACUBE, id }} />
  );
}
